import ConnectedJobActions from './ConnectedJobActions'

export default ConnectedJobActions
